import { useAppStore } from '@/store/useAppStore'

export default function buildOrgPath(path: string): `/${string}` {
  const orgId = useAppStore.getState().currentOrganization.organization?.id
  if (!orgId) return path as `/${string}`
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `/organization/${orgId}${normalized}` as `/${string}`
}
